import React from "react";
import {Label} from "flowbite-react";
import {useErrorReporter} from "./ErrorViewer";
import {useTranslation} from "react-i18next";
import {useAuth} from "../auth/AuthHook";
import {useQuery} from "@tanstack/react-query";
import {UserInfo, UserInfoBase} from "../support/model";
import {withBase} from "../utils/basePath";

export interface UserNameTagProps {
    userId?: string
    label?: string
    extraClassNames?: string
    extraLabelClassNames?: string
    userNameCallback?: (name: string) => void
}

export function UserNameTag({userId, label, extraClassNames, extraLabelClassNames, userNameCallback}: UserNameTagProps) {
    const {getHeaders, isLoggedIn} = useAuth();
    const reporter = useErrorReporter()
    const {t} = useTranslation()
    const isUserLoggedIn = isLoggedIn();
    const fetchUserCreated = async (): Promise<UserInfoBase | undefined> => {
        if (!isUserLoggedIn) {
            return undefined
        }
        try {
            if (userId === undefined || userId === "") {
                return undefined
            }
            const response = await fetch(withBase(`api/users/${userId}`), {
                method: "GET",
                headers: await getHeaders(),
                cache: "force-cache",
            });
            if (response.status == 404) {
                return {
                    user_id: userId,
                    name: `id (no entry): ${userId}`
                }
            }
            if (!response.ok || response.status > 299) {
                const errorMsg = await response.text()
                reporter(errorMsg)
                return
            }
            const respJson = await response.json()
            userNameCallback?.(respJson["name"])

            return respJson as UserInfo
        } catch (e) {
            reporter(`Error fetching user data: ${e}`)
        }
    }


    const {data: userData, isLoading, error} = useQuery({
        queryKey: ['user', userId, isUserLoggedIn],
        queryFn: () => fetchUserCreated(),
        enabled: isUserLoggedIn && userId != null && userId !== "",
        staleTime: 5 * 60 * 1000,
    })

    return (
        <div>
            <div className={`mb-2 block ${label === undefined ? "hidden" : ""}`}>
                <Label className={extraLabelClassNames} htmlFor={`display-name-id-${userId}`}>
                    {label}
                </Label>
            </div>
            <div id={`display-name-id-${userId}`} className={`${extraClassNames}`}>
                {(!isUserLoggedIn || userId == undefined) && "Someone (from the organization)"}
                {userData && userData.name}
                {isLoading && "Loading..."}
                {error && !isLoading && t("Error loading user")}
            </div>

        </div>
    )
}